module.exports = __webpack_public_path__ + "images/pages/lp/comment_balloon_9_1df70f1a9b455b0e2d008101ab9d6f5d.png";